export const pagesInfo = [
  {
    index: 0,
    page: "Ideation",
    tag: "Search and generate ideas for your next video!",
  },
  {
    index: 1,
    page: "Saved-Ideas",
    tag: "Find here all your video ideas and briefings",
  },
  {
    index: 2,
    page: "Insights",
    tag: "Search and generate ideas for your next video!",
  },
  {
    index: 3,
    page: "Competition",
    tag: "Search and generate ideas for your next video!",
  },
  {
    index: 4,
    page: "Optimization",
    tag: "Implement our optimization recommendations to increase your organic reach",
  },
  {
    index: 5,
    page: "Optimize",
    tag: "Search and generate ideas for your next video!",
  },
  {
    index: 6,
    page: "Reporting",
    tag: "Your Channel Report",
  },
  {
    index: 7,
    page: "Ranking",
    tag: "Monitor your Keyword Ranks",
  },
  {
    index: 8,
    page: "Keywords",
    tag: "Set up and manage your channel keywords",
  },
  {
    index: 9,
    page: "Settings",
    tag: "Search and generate ideas for your next video!",
  },
  {
    index: 10,
    page: "Keywords",
    tag: "Search and generate ideas for your next video!",
  },
  {
    index: 10,
    page: "Ai-Generator",
    tag: "Utilize our AI tool to create youtube posts in seconds",
  },
];
